import { connect } from 'react-redux'
import ImageSlideCreateDialog from './create-dialog.jsx'
import { createSlide } from '../../../../stores/presentation/presentation.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'

const mapStateToProps = state => {
  const createSlideDialog = getCreateSlideDialog(state)
  return {
    modalOpened: createSlideDialog.opened && createSlideDialog.type === 'Video'
  }
}

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeCreateSlideDialog()),
  onSubmit: values => {
    dispatch(
      createSlide({
        type: 'Video',
        title: values.title,
        text: values.text,
        html_text: values.html,
        video_url: values.url
      })
    ).catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageSlideCreateDialog)
